import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFerrariComponent } from './simple-icons-ferrari.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFerrariComponent ],
    exports:      [ SimpleIconsFerrariComponent ],
    bootstrap:    []
})
export class SimpleIconsFerrariModule {}
